import { ErrorIcon } from "../../../shared/icons/ErrorIcon";
import styles from "./styles.module.css";

interface Props {
  className?: string;
}

export const ErrorBoundaryFallback = ({ className }: Props) => {
  return (
    <div className={styles["fallback"]}>
      <div className={styles["error-message"]}>
        <ErrorIcon />
        <div>В процессе обработки данных произошла ошибка</div>
      </div>
    </div>
  );
};
